import React, { useState, useCallback } from "react";
import styled from "styled-components";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import CallToAction from "../components/CallToAction";
import IntroBand from "../components/IntroBand";

const Hero = styled.div`
  z-index: 3;
  position: relative;

  nav {
    z-index: 3;
    position: relative;
  }
`;

const Title = styled.div`
  font-family: Raleway;
  font-size: 40px;
  font-weight: 400;
  line-height: 1.3;
  text-align: left;
  color: black;
  padding-top: 50px;
`;

const ArrowLink = styled.a`
  color: #5e8a64;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.3;

  position: relative;
  padding-right: 40px;
  cursor: pointer;
  text-decoration: none;

  &::after {
    content: url("../images/arrow.svg");
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: right ease 0.4s;
  }

  &:hover {
    opacity: 0.8;
    &::after {
      right: -10px;
    }
  }
  &:active {
    opacity: 0.5;
  }
`;

const ImproveWellbeing = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1184px;
  padding: 0 30px;

  img {
    width: 350px;
  }

  .text-block {
    width: 652px;
  }

  .text-block p {
    margin: 30px 30px 30px 0;
  }

  @media screen and (max-width: 970px) {
    flex-direction: column;
    text-align: center;
    flex-direction: column-reverse;

    .text-block p {
      margin: 30px auto;
    }
  }
`;

const Gap50 = styled.div`
  display: block;
  height: 50px;
`;

const IntroBandAuthor = styled.div`
  font-family: Raleway;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  margin-top: 15px;
`;

const AnchorList = styled.p`
  text-align: left;
`;

function Therapy() {
  return (
    <div>
      <main>
        <div className="green-bg">
          <Hero>
            <Nav />
            <ImproveWellbeing id="improve-wellbeing" className="scroll-fade-in">
              <div className="text-block">
                <Title>Mental Health Counseling Services</Title>
                <AnchorList>
                  We offer telehealth and in-person talk therapy using a wide-range of treatments and modalities. We specialize in the following.<br/><br/>
                  I want to learn more about how you treat...<br/>
                  <ArrowLink href="/depression-therapy">Depression</ArrowLink><br/>
                  <ArrowLink href="/anxiety-therapy">Anxiety</ArrowLink><br/>
                  <ArrowLink href="/adhd-therapy">ADHD</ArrowLink><br/>
                  <ArrowLink href="/trauma-therapy">Trauma</ArrowLink><br/>
                  <ArrowLink href="/ptsd-therapy">PTSD</ArrowLink><br/><br/>
                  I want to learn more about the modality...<br/>
                  <ArrowLink href="/emdr-modality">EMDR</ArrowLink><br/>
                  <ArrowLink href="/dbt-modality">DBT</ArrowLink><br/>
                  <ArrowLink href="/cbt-modality">CBT</ArrowLink><br/>
                  <ArrowLink href="/ifs-modality">IFS</ArrowLink><br/>
                  <ArrowLink href="/act-modality">ACT</ArrowLink><br/>
                </AnchorList>
                <p>If you're ready to take the next step<br/>
                <ArrowLink href="/contact">Contact Us</ArrowLink></p>
              </div>
              <img
                src="images/two-women-conversing-in-office.png"
                alt="Two women having a conversation in an office environment"
              />
            </ImproveWellbeing>
            </Hero>
            <IntroBand>
              <Gap50 />
              "Between stimulus and response there is a space. In that space is
              our power to choose our response. In our response lies our growth
              and our freedom."
              <IntroBandAuthor>- Viktor E. Frankl</IntroBandAuthor>
            </IntroBand>
          </div>
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}

export default Therapy;
